import { render, staticRenderFns } from "./BankAccountSelector.vue?vue&type=template&id=457a416f&scoped=true"
import script from "./BankAccountSelector.vue?vue&type=script&lang=js"
export * from "./BankAccountSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457a416f",
  null
  
)

export default component.exports